import script from "./device-table.vue?vue&type=script&setup=true&lang=js"
export * from "./device-table.vue?vue&type=script&setup=true&lang=js"

import "./device-table.vue?vue&type=style&index=0&id=72f03320&lang=scss&scoped=true"

import exportComponent from "C:\\Project\\DeepLink\\OrionRaceWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f03320"]])

export default __exports__